import React from 'react';
// Import Global Components
import { Loader, Title } from 'shared-components';
// Import Component Styles
import { ConfirmTransferModal } from './styles';

export default function() {
  return <ConfirmTransferModal>
    <Title>Processing Collection...</Title>
    <Loader />
  </ConfirmTransferModal>;
};
